export default __webpack_public_path__ + "324f70b5220a9388cc443dff44cf13ab.png";